/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "ebhtqxdvtbwgopzbejwu"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImViaHRxeGR2dGJ3Z29wemJland1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTkzMTk0ODgsImV4cCI6MjA3NDg5NTQ4OH0.fdMHXSXGst5hDzOXDuO5xDrYQg5LlHL4W1iRcYfluik"